import * as React from 'react';
import { ColorChangeHandler } from 'react-color';

// tslint:disable-next-line:no-var-requires
const { Swatch } = require('react-color/lib/components/common')

export interface IPresetColorsProps {
    colors: any[];
    onClick: ColorChangeHandler | undefined;
}

export const PresetColors = (props: IPresetColorsProps) => {
    return (
        <div className="flexbox-fix presetcolors-root">
          { props.colors.map((colorObjOrString) => {
            const c = typeof colorObjOrString === 'string'
              ? { color: colorObjOrString }
              : colorObjOrString
            const key = `${c.color}${c.title || ''}`
            return (
              <div key={ key } style={{
                width: '16px',
                height: '16px',
                margin: '0 10px 10px 0',
              }}>
                <Swatch
                  { ...c }
                  style={{
                    borderRadius: '3px',
                    boxShadow: 'inset 0 0 0 1px rgba(0,0,0,.15)',
                  }}
                  onClick={props.onClick}
                  focusStyle={{
                    boxShadow: `inset 0 0 0 1px rgba(0,0,0,.15), 0 0 4px ${ c.color }`,
                  }}
                />
              </div>
            )
          }) }
        </div>
      )
}



// WEBPACK FOOTER //
// ./src/App/shared/components/preset-colors.component.tsx